import { render } from "./BottomCart.vue?vue&type=template&id=6ae677c4&scoped=true"
import script from "./BottomCart.vue?vue&type=script&lang=js"
export * from "./BottomCart.vue?vue&type=script&lang=js"

import "./BottomCart.vue?vue&type=style&index=0&id=6ae677c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ae677c4"

export default script